//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '../../../src/lib/util';
import fileUploader from '../../views/common-components/file-uploader';

export default {
    name: 'albumsEdit1',
    components: {
        fileUploader
    },
    data() {
        const vm = this;
        return {
            loading: false,
            saving: false,
            albumId: 0,
            albumType: 'AlbumImage',
            album: {},
            albumRules: {
                name: {
                    required: true,
                    message: '请输名称',
                    trigger: 'blur'
                }
            },
            projects: []
        };
    },
    methods: {
        getAlbum() {
            this.loading = true;
            this.album = {};
            abp.ajax.get('/api/services/app/Album/GetAlbumById?id=' + this.albumId)
                .then((resp) => {
                    this.album = resp.data.result;
                }).finally(() => {
                this.loading = false;
            });
        },
        saveAlbum() {
            this.$refs.albumForm.validate(async (val) => {
                this.saving = true;
                abp.ajax.post('/api/services/app/Album/SaveAlbum', this.album).then(
                    (resp) => {
                        this.$router.push({
                            path: '/activity/albumList'
                        });
                        this.saving = false;
                    }, (error) => {
                        this.saving = false;
                    });
            });
        },
        getProjects() {
            this.$store.dispatch({
                type: 'project/getProjects'
            }).then(() => {
                this.projects = this.$store.state.project.projects;
            });
        }
    },
    created() {
        let parames = JSON.parse(this.$route.params.datas);
        this.albumId = parames.id;
        let businessId = parames.businessId;
        let businessType = parames.businessType;
        if (this.albumId != 0) {
            this.getAlbum();
        } else {
            this.album = {
                businessId: businessId,
                businessType: businessType
            };
        }
        this.getProjects();
    },
    computed: {},
    mounted() {
    },
    watch: {
        // $route: {
        //     handler: function (val, oldVal) {
        //         if (this.$route.params.datas != undefined) {
        //             let parames = JSON.parse(this.$route.params.datas);
        //             this.albumId = parames.id;
        //             let businessId = parames.businessId;
        //             let businessType = parames.businessType;
        //             if (this.albumId != 0) {
        //                 this.getAlbum();
        //             } else {
        //                 this.album = {
        //                     businessId: businessId,
        //                     businessType: businessType
        //                 };
        //             }
        //         }
        //
        //     },
        //     deep: true
        // }
    }

};
